import { BatchedOperationError } from '@/user_files/batching/errors'
import { DeleteSelectionRequest, DeleteSelectionResponse } from './schemas'

export class BatchedDeleteSelectionError extends BatchedOperationError<DeleteSelectionRequest, DeleteSelectionResponse> {
  constructor(params: { message: string; partialResult: DeleteSelectionResponse; failedBatch: DeleteSelectionRequest; cause?: unknown }) {
    super(params)
    this.name = 'BatchedDeleteSelectionError'
  }
}
